import { render, staticRenderFns } from "./ed-subject-day-content.component.vue?vue&type=template&id=44e19cae&scoped=true&"
import script from "./ed-subject-day-content.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-day-content.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-day-content.component.scss?vue&type=style&index=0&id=44e19cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e19cae",
  null
  
)

export default component.exports